// extracted by mini-css-extract-plugin
export var parcelRow = "_ut-0";